export default "__VITE_ASSET__fd603852__"